import * as subjectsActions from './actions'
import { Record } from '../transit'

const State = Record({
  all: [],
  current: null,
}, 'subjects')

const subjectsReducer = (state = new State(), action) => {
  switch (action.type) {
    case subjectsActions.SUBJECT_LOAD_SUCCESS:
    case subjectsActions.SUBJECT_ADD_SUCCESS: {
      return state.set('current', action.payload.data)
    }
    case subjectsActions.SUBJECTS_LOAD_SUCCESS: {
      const subjects = action.payload.data

      return state.set('all', subjects)
    }
    case subjectsActions.SUBJECTS_CLEAR: {
      return state.set('all', [])
    }
    case subjectsActions.SUBJECT_CLEAR: {
      return state.set('current', null)
    }
    default: {
      return state
    }
  }
}

export default subjectsReducer



// WEBPACK FOOTER //
// ./src/common/subjects/reducer.js